"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommandsIterable = void 0;

var symbols_1 = require("../../symbols");

var CommandsIterable = /*#__PURE__*/function (_Symbol$iterator, _symbols_1$cloneMetho) {
  function CommandsIterable(commands, metadataForReplay) {
    _classCallCheck(this, CommandsIterable);

    this.commands = commands;
    this.metadataForReplay = metadataForReplay;
  }

  _createClass(CommandsIterable, [{
    key: _Symbol$iterator,
    value: function value() {
      return this.commands[Symbol.iterator]();
    }
  }, {
    key: _symbols_1$cloneMetho,
    value: function value() {
      return new CommandsIterable(this.commands.map(function (c) {
        return c.clone();
      }), this.metadataForReplay);
    }
  }, {
    key: "toString",
    value: function toString() {
      var serializedCommands = this.commands.filter(function (c) {
        return c.hasRan;
      }).map(function (c) {
        return c.toString();
      }).join(',');
      var metadata = this.metadataForReplay();
      return metadata.length !== 0 ? "".concat(serializedCommands, " /*").concat(metadata, "*/") : serializedCommands;
    }
  }]);

  return CommandsIterable;
}(Symbol.iterator, symbols_1.cloneMethod);

exports.CommandsIterable = CommandsIterable;